export class RefreshTokenInvalidError extends Error {
  constructor() {
    super('Refresh token invalid or expired')
    this.name = 'RefreshTokenInvalidError'
  }
}
